import { gql } from "@apollo/client";

export const UPDATE_SUBSCRIPTION_PAYMENT_METHOD = gql`
mutation updateSubscriptionPaymentMethod(
  $wellnessId: String!, $cardId: String!
) {
  updateSubscriptionPaymentMethod(wellnessId: $wellnessId, cardId: $cardId) {
    success
    messages
  }
}`;
